<table class="w-full">
  @if (!showMobileLayout()) {
    <thead>
      <tr>
        @for (column of columns(); track column.field; let first = $first; let last = $last) {
          <th
            scope="col"
            [class]="headerClass()"
            [ngClass]="{
              'cursor-pointer': column.sortable,
              'rounded-tl-xl': first,
              'rounded-tr-xl': last && actions().length === 0,
            }"
            (click)="column.sortable ? changeSort(column.field) : null"
          >
            @if (sortBy()?.field === column.field && sortBy()?.direction === 'desc') {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="currentColor"
                viewBox="0 0 16 16"
                class="inline"
              >
                <path
                  d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                />
              </svg>
            } @else if (sortBy()?.field === column.field && sortBy()?.direction === 'asc') {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="currentColor"
                class="inline"
                viewBox="0 0 16 16"
              >
                <path
                  d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                />
              </svg>
            } @else if (sortBy()?.field !== column.field && column.sortable) {
              <span class="text-text-secondary">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="15"
                  viewBox="0 0 16 20"
                  fill="currentColor"
                  class="inline"
                >
                  <path
                    d="m 7.0453508,17.14 -4.796,-5.482 c -0.566,-0.645 -0.106,-1.658 0.753,-1.658 h 9.5920002 a 1,1 0 0 1 0.753,1.659 l -4.7960002,5.48 a 1,1 0 0 1 -1.506,0 z"
                  />
                  <path
                    d="m 7.0453508,1.3409795 -4.796,5.481 c -0.566,0.6469999 -0.106,1.6589999 0.753,1.6589999 h 9.5920002 a 1,1 0 0 0 0.753,-1.6589999 l -4.7960002,-5.48 a 1,1 0 0 0 -1.506,0 z"
                  />
                </svg>
              </span>
            }

            {{ column.title }}
          </th>
        }
        @if (actions().length > 0) {
          <th [class]="headerClass()" class="rounded-tr-xl"></th>
        }
      </tr>
    </thead>
  }
  <tbody>
    @if (isLoading()) {
      <tr class="border-y border-spacing-y-8 border-gray">
        @if (showMobileLayout()) {
          <td><ngx-skeleton-loader [count]="skeletonLoadingLines()" appearance="line" /></td>
          <td><ngx-skeleton-loader [count]="skeletonLoadingLines()" appearance="line" /></td>
        } @else {
          @for (column of columns(); track column.field) {
            <td><ngx-skeleton-loader [count]="skeletonLoadingLines()" appearance="line" /></td>
          }
          @if (actions().length > 0) {
            <td><ngx-skeleton-loader [count]="skeletonLoadingLines()" appearance="line" /></td>
          }
        }
      </tr>
    } @else {
      @for (item of data(); track item['id'].value; let index = $index) {
        <tr
          class="border-y border-spacing-y-8 border-gray hover:bg-background-1 hover:bg-opacity-30"
          (click)="onRowClick.emit({ row: item, rowIndex: index })"
        >
          @if (showMobileLayout()) {
            <td>
              <div>
                @for (column of columns(); track column.field) {
                  <div class="flex my-2">
                    <span class="inline-block w-1/3 pr-4 overflow-x-hidden font-bold text-left">
                      {{ column.title }}
                    </span>
                    <span class="inline-block w-2/3">
                      <ng-container
                        [ngTemplateOutlet]="cellValue"
                        [ngTemplateOutletContext]="{ item: item, column: column, index: index }"
                      />
                    </span>
                  </div>
                }
              </div>
            </td>
          } @else {
            @for (column of columns(); track column.field) {
              <td class="px-4 py-4">
                <ng-container
                  [ngTemplateOutlet]="cellValue"
                  [ngTemplateOutletContext]="{ item: item, column: column, index: index }"
                />
              </td>
            }
          }
          @if (actions().length > 0) {
            <td>
              <div class="flex items-center gap-2">
                @for (action of actions(); track action) {
                  <button
                    (click)="
                      onActionClick.emit({ action: action, row: item, rowIndex: index });
                      $event.stopPropagation()
                    "
                    class="text-text-primary hover:text-text-link hover:cursor-pointer"
                  >
                    <ng-container
                      [ngTemplateOutlet]="actionsDisplay"
                      [ngTemplateOutletContext]="{ action: action }"
                    />
                  </button>
                }
              </div>
            </td>
          }
        </tr>
      } @empty {
        <tr>
          <td
            [attr.colspan]="columns().length + actions().length"
            class="py-4 text-center text-text-secondary"
          >
            {{ textIfEmpty() }}
          </td>
        </tr>
      }
    }
  </tbody>
</table>

<ng-template #cellValue let-item="item" let-column="column" let-index="index">
  @if (item[column.field]) {
    @if (column.formatter?.includes('internal_link')) {
      <a [routerLink]="item[column.field].link" class="hover:text-text-link">
        <ng-container
          [ngTemplateOutlet]="displayText"
          [ngTemplateOutletContext]="{ item: item, column: column, index: index }"
        />
      </a>
    } @else if (column.formatter?.includes('external_link')) {
      <a [href]="item[column.field].link" class="hover:text-text-link" target="_blank">
        <ng-container
          [ngTemplateOutlet]="displayText"
          [ngTemplateOutletContext]="{ item: item, column: column, index: index }"
        />
      </a>
    } @else {
      <ng-container
        [ngTemplateOutlet]="displayText"
        [ngTemplateOutletContext]="{ item: item, column: column, index: index }"
      />
    }
  }
</ng-template>

<ng-template #displayText let-item="item" let-column="column" let-index="index">
  @if (item[column.field].bold_value) {
    <span class="font-bold">
      {{ item[column.field].bold_value }}
    </span>
    <br />
  }
  @if (column.formatter?.includes('date')) {
    @if (item[column.field].value.split('/')[1]) {
      {{ item[column.field].value.split('/')[0].trim() | date: 'dd.MM.yyyy' }} -
      {{ item[column.field].value.split('/')[1].trim() | date: 'dd.MM.yyyy' }}
    } @else {
      {{ item[column.field].value | date: 'dd.MM.yyyy' }}
    }
  } @else if (column.formatter?.includes('dateTime')) {
    @if (item[column.field].value.split('/')[1]) {
      {{ item[column.field].value.split('/')[0].trim() | date: 'HH:mm - dd.MM.yyyy' }}
      <br />
      {{ item[column.field].value.split('/')[1].trim() | date: 'HH:mm - dd.MM.yyyy' }}
    } @else {
      {{ item[column.field].value | date: 'HH:mm - dd.MM.yyyy' }}
    }
  } @else if (column.formatter?.includes('image')) {
    @if (item[column.field].imageValue) {
      <img
        src="{{ item[column.field].imageValue }}"
        alt="Image"
        class="object-scale-down w-20 h-20"
        handleMissingImage
      />
    } @else {
      {{ item[column.field].value }}
    }
  } @else if (column.formatter?.includes('tag')) {
    <axpo-tag [type]="item[column.field].value">
      {{ item[column.field].tagTranslation || item[column.field].value }}
    </axpo-tag>
  } @else if (column.formatter?.includes('roleTag') && item[column.field].valueArray) {
    <div class="flex flex-wrap gap-2">
      @for (role of item[column.field].valueArray; track role) {
        <axpo-tag [roles]="role" [variant]="'ghost'">
          {{ role | formatText }}
        </axpo-tag>
      }
    </div>
  } @else if (column.formatter?.includes('actions')) {
    <div class="flex items-center gap-2">
      @for (action of item[column.field].valueArray; track action) {
        <button
          (click)="
            onActionClick.emit({ action: action, row: item, rowIndex: index });
            $event.stopPropagation()
          "
          class="text-text-primary hover:text-text-link hover:cursor-pointer"
        >
          <ng-container
            [ngTemplateOutlet]="actionsDisplay"
            [ngTemplateOutletContext]="{ action: action }"
          />
        </button>
      }
    </div>
  } @else {
    {{ item[column.field].value }}
  }
</ng-template>

<ng-template #actionsDisplay let-action="action">
  @switch (action) {
    @case ('edit') {
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="operation/edit">
          <mask
            id="mask0_10469_12808"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_10469_12808)">
            <path
              id="vector"
              d="M3 21.5164C2.73205 21.5164 2.4984 21.4199 2.29905 21.227C2.09968 21.034 2 20.7972 2 20.5164C2 20.2485 2.09968 20.0148 2.29905 19.8154C2.4984 19.6161 2.73205 19.5164 3 19.5164H21C21.268 19.5164 21.5016 19.6129 21.701 19.8059C21.9003 19.9988 22 20.2356 22 20.5164C22 20.7844 21.9003 21.018 21.701 21.2174C21.5016 21.4167 21.268 21.5164 21 21.5164H3ZM5.80768 16.5164C5.57563 16.5164 5.383 16.4398 5.2298 16.2866C5.0766 16.1334 5 15.9408 5 15.7087V14.4799C5 14.3722 5.01859 14.2718 5.05578 14.1789C5.09294 14.0859 5.15512 13.9959 5.2423 13.9087L13.8192 5.37023L16.1462 7.69715L7.6077 16.2741C7.52052 16.3613 7.43045 16.4234 7.3375 16.4606C7.24455 16.4978 7.14423 16.5164 7.03655 16.5164H5.80768ZM6 15.5164H6.9L14.7308 7.69715L13.8192 6.78563L6 14.6164V15.5164ZM17.0404 6.71255L14.7135 4.42408L15.8596 3.27793C16.043 3.09075 16.2699 2.99811 16.5404 3.00003C16.8109 3.00196 17.0378 3.0946 17.2212 3.27793L18.1481 4.20486C18.3314 4.38819 18.4295 4.61415 18.4423 4.88273C18.4551 5.15133 18.3699 5.37922 18.1866 5.56641L17.0404 6.71255Z"
            />
          </g>
        </g>
      </svg>
    }
    @case ('delete') {
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="file/delete">
          <mask
            id="mask0_10469_12488"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="25"
            height="24"
          >
            <rect id="Bounding box" x="0.5" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_10469_12488)">
            <path
              id="vector"
              d="M7.49512 21.1155C6.96976 21.1155 6.53111 20.9395 6.17916 20.5876C5.82721 20.2356 5.65123 19.7969 5.65123 19.2716V5.13501H5.0805C4.91805 5.13501 4.78232 5.0805 4.67331 4.97147C4.56428 4.86244 4.50977 4.72671 4.50977 4.56428C4.50977 4.40183 4.56428 4.2661 4.67331 4.15709C4.78232 4.04806 4.91805 3.99355 5.0805 3.99355H9.07562C9.07562 3.7433 9.16672 3.5344 9.34892 3.36683C9.53111 3.19926 9.74734 3.11548 9.99758 3.11548H15.0024C15.2527 3.11548 15.4689 3.19926 15.6511 3.36683C15.8333 3.5344 15.9244 3.7433 15.9244 3.99355H19.9195C20.082 3.99355 20.2177 4.04806 20.3267 4.15709C20.4357 4.2661 20.4903 4.40183 20.4903 4.56428C20.4903 4.72671 20.4357 4.86244 20.3267 4.97147C20.2177 5.0805 20.082 5.13501 19.9195 5.13501H19.3488V19.2716C19.3488 19.7969 19.1728 20.2356 18.8209 20.5876C18.4689 20.9395 18.0303 21.1155 17.5049 21.1155H7.49512ZM6.79269 5.13501V19.2716C6.79269 19.4765 6.85855 19.6448 6.99025 19.7765C7.12196 19.9082 7.29025 19.974 7.49512 19.974H17.5049C17.7098 19.974 17.8781 19.9082 18.0098 19.7765C18.1415 19.6448 18.2073 19.4765 18.2073 19.2716V5.13501H6.79269ZM9.99755 17.1204C9.99755 17.2828 10.0521 17.4185 10.1611 17.5276C10.2701 17.6366 10.4059 17.6911 10.5683 17.6911C10.7307 17.6911 10.8665 17.6366 10.9755 17.5276C11.0845 17.4185 11.139 17.2828 11.139 17.1204V7.98867C11.139 7.82624 11.0845 7.69051 10.9755 7.58148C10.8665 7.47245 10.7307 7.41793 10.5683 7.41793C10.4059 7.41793 10.2701 7.47245 10.1611 7.58148C10.0521 7.69051 9.99755 7.82624 9.99755 7.98867V17.1204ZM13.861 17.1204C13.861 17.2828 13.9155 17.4185 14.0245 17.5276C14.1336 17.6366 14.2693 17.6911 14.4317 17.6911C14.5942 17.6911 14.7299 17.6366 14.8389 17.5276C14.948 17.4185 15.0025 17.2828 15.0025 17.1204V7.98867C15.0025 7.82624 14.948 7.69051 14.8389 7.58148C14.7299 7.47245 14.5942 7.41793 14.4317 7.41793C14.2693 7.41793 14.1336 7.47245 14.0245 7.58148C13.9155 7.69051 13.861 7.82624 13.861 7.98867V17.1204ZM6.79269 5.13501V19.2716C6.79269 19.4765 6.85855 19.6448 6.99025 19.7765C7.12196 19.9082 7.29025 19.974 7.49512 19.974H6.79269V5.13501Z"
            />
          </g>
        </g>
      </svg>
    }
    @case ('view') {
      <svg
        version="1.2"
        id="Ebene_1"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        overflow="visible"
        xml:space="preserve"
        width="24"
        height="24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:svg="http://www.w3.org/2000/svg"
      >
        <defs id="defs15" />
        <g
          id="g10"
          transform="matrix(0.81300813,0,0,0.81300813,-7.625203,-7.026829)"
          style="stroke-width: 1.23"
        >
          <path
            d="M 24.4,32.1 C 17.7,32.1 13,26.2 12.8,25.9 l -0.1,-0.2 0.1,-0.2 c 0,-0.1 3.8,-9.5 11.8,-9.6 1.3,0 2.5,0.2 3.6,0.6 0.2,0.1 0.3,0.3 0.2,0.5 -0.1,0.2 -0.3,0.3 -0.5,0.2 -1,-0.4 -2.2,-0.6 -3.4,-0.6 -6.9,0.1 -10.5,7.6 -11.1,9 0.9,1 5.9,6.5 12.4,5.6 7.7,-1.1 10.3,-5.7 10.7,-6.6 -0.5,-0.8 -2.7,-4.2 -6.2,-6.3 -0.2,-0.1 -0.2,-0.3 -0.1,-0.5 0.1,-0.2 0.3,-0.2 0.5,-0.1 4,2.5 6.4,6.6 6.5,6.7 l 0.1,0.2 -0.1,0.2 c -0.1,0.2 -2.4,5.9 -11.4,7.2 -0.3,0 -0.9,0.1 -1.4,0.1 z"
            id="path2"
            style="stroke-width: 1.5129"
          />
          <path
            fill="none"
            stroke-width="0.9225"
            stroke-linecap="round"
            stroke-miterlimit="10"
            d="M 30.7,18"
            id="path4"
          />
          <path
            d="m 24.7,29 c -2.7,0 -5,-2.2 -5,-5 0,-2.8 2.2,-5 5,-5 2.8,0 5,2.2 5,5 0,2.8 -2.2,5 -5,5 z m 0,-9.2 c -2.3,0 -4.2,1.9 -4.2,4.2 0,2.3 1.9,4.2 4.2,4.2 2.3,0 4.2,-1.9 4.2,-4.2 0.1,-2.3 -1.8,-4.2 -4.2,-4.2 z"
            id="path6"
            style="stroke-width: 1.5129"
          />
          <path
            d="m 24.8,26.7 c -1.5,0 -2.8,-1.2 -2.8,-2.8 0,-1.6 1.2,-2.8 2.8,-2.8 1.6,0 2.8,1.2 2.8,2.8 0,1.6 -1.2,2.8 -2.8,2.8 z m 0,-4.8 c -1.1,0 -2,0.9 -2,2 0,1.1 0.9,2 2,2 1.1,0 2,-0.9 2,-2 0.1,-1.1 -0.9,-2 -2,-2 z"
            id="path8"
            style="stroke-width: 1.5129"
          />
        </g>
      </svg>
    }
    @case ('pdf') {
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="file/file_pdf">
          <path
            id="Vector"
            d="M18.6663 22H5.04083C4.47311 22 4 21.5595 4 21.0308V3.14537C4 2.52863 4.56773 2 5.23007 2H15.2599C15.6384 2 16.0169 2.08811 16.3007 2.35242L17.1523 3.05727C17.3416 3.14538 17.3416 3.40969 17.1523 3.4978C17.0577 3.67401 16.7738 3.67401 16.6792 3.4978L15.8276 2.79295C15.733 2.70485 15.5438 2.61674 15.2599 2.61674H5.23007C4.94621 2.61674 4.75697 2.79295 4.75697 3.05727V21.0308C4.75697 21.2071 4.85159 21.2952 5.04083 21.2952H18.6663C19.0447 21.2952 19.3286 21.0308 19.3286 20.6784V6.22908C19.3286 6.05287 19.234 5.87665 19.0447 5.70044L18.0985 4.90749C17.9093 4.81938 17.9093 4.55507 18.0985 4.46696C18.1932 4.29075 18.477 4.29075 18.5716 4.46696L19.5179 5.25991C19.8963 5.61234 19.991 5.87665 19.991 6.31718V20.7665C20.0856 21.3833 19.4232 22 18.6663 22Z"
          />
          <path
            id="vector"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.2302 10.6729L12.223 10.7066C12.5048 11.4391 12.8926 11.9306 13.4851 12.292C14.6894 12.1426 15.4626 12.2245 15.7805 12.5377C15.9997 12.757 16.0648 13.1666 15.9299 13.4919C15.8528 13.6774 15.6481 13.9858 15.1278 13.9858C14.6027 13.9858 13.8295 13.7521 13.1503 13.3883C12.5446 13.4904 11.8757 13.7168 11.229 13.9356L11.2017 13.9448C11.062 13.993 10.9175 14.0412 10.7778 14.087C9.86248 15.6579 9.17601 16 8.75209 16C8.65093 16 8.56421 15.9783 8.49195 15.9518C8.32576 15.8892 8.18365 15.7591 8.09453 15.5904C8.01504 15.4386 7.98132 15.27 8.01022 15.1374C8.15233 14.4195 9.10857 13.8508 9.82153 13.4822C10.2045 12.8076 10.7272 11.6728 11.0548 10.8922C10.7946 9.88504 10.6525 9.09477 10.8115 8.51652C10.8958 8.2009 11.2354 7.98405 11.616 8.00092C11.9387 8.01538 12.3169 8.21535 12.4084 8.72855C12.545 9.3755 12.3718 10.0892 12.2325 10.6634L12.2302 10.6729ZM11.6521 11.5957C11.9098 12.0414 12.235 12.4245 12.5939 12.7088C12.0789 12.8257 11.6088 13.0181 11.1881 13.1902L11.1752 13.1955C11.1338 13.2122 11.0929 13.229 11.0524 13.2456C10.9937 13.2695 10.9359 13.2932 10.8789 13.316C11.1993 12.7353 11.4666 12.0776 11.6521 11.5957ZM11.7027 9.88263C11.799 9.55496 11.8159 8.90684 11.6906 8.69241C11.6738 8.66108 11.6569 8.64663 11.6377 8.64422C11.5678 8.72373 11.5847 9.40317 11.7027 9.88263ZM15.4 13.1738C15.4024 13.1786 15.4048 13.1859 15.3903 13.1955H15.3855L15.3807 13.2027C15.3614 13.2148 15.1639 13.3304 14.3137 12.9955C15.2628 12.9511 15.3906 13.1586 15.3995 13.173L15.4 13.1738ZM9.58067 14.3665C9.24586 14.8531 8.99295 15.0965 8.85566 15.2025C9.01704 14.9061 9.33257 14.5929 9.58067 14.3665Z"
          />
        </g>
      </svg>
    }
    @case ('download') {
      <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="shape">
          <path
            id="Path"
            d="M19.5285 7.98471C19.2694 7.98798 19.0603 8.19002 19.0569 8.44023V16.3359C19.0569 16.7552 18.705 17.0951 18.271 17.0951H1.77931C1.34322 17.0918 0.990532 16.7511 0.987111 16.3298L0.9431 8.43416C0.9431 8.18258 0.73198 7.97864 0.47155 7.97864C0.21112 7.97864 0 8.18258 0 8.43416L0.0440113 16.3298C0.0542726 17.2505 0.82621 17.9935 1.77931 18.0001H18.271C19.2259 18.0001 20 17.2523 20 16.3298V8.43416C19.9966 8.18496 19.7864 7.98469 19.5285 7.98471Z"
          />
          <path
            id="Path_2"
            d="M9.96255 12.9481C10.0309 13.0239 10.1212 13.0776 10.2215 13.1023C10.2551 13.1058 10.289 13.1058 10.3226 13.1023H10.411C10.4425 13.1051 10.4742 13.1051 10.5057 13.1023C10.6067 13.0792 10.6974 13.0252 10.7647 12.9481L14.2764 8.55811C14.4173 8.36413 14.3845 8.09747 14.2006 7.94153C13.9942 7.78347 13.6961 7.81642 13.5311 8.01552L10.8531 11.3019V0.462434C10.8531 0.207039 10.641 0 10.3794 0C10.1178 0 9.9057 0.207039 9.9057 0.462434V11.3512L7.19611 7.96619C7.03341 7.76785 6.73726 7.73481 6.53292 7.89221C6.34414 8.0449 6.30829 8.31404 6.45081 8.50878L9.96255 12.9481Z"
          />
        </g>
      </svg>
    }
  }
</ng-template>
